export default class Constraints {
  _maxScaleX;
  _maxScaleY;
  _maxX;
  _maxY;
  _minScaleX;
  _minScaleY;
  _minX;
  _minY;

  /**
   * Create an object that represents the extrema of an object can be transformed.
   *
   * @param {Number} minScaleX
   * @param {Number} minScaleY
   * @param {Number} maxScaleX
   * @param {Number} maxScaleY
   * @param {Number} minX
   * @param {Number} minY
   * @param {Number} maxX
   * @param {Number} maxY
   */
  constructor(
    minScaleX,
    minScaleY,
    maxScaleX,
    maxScaleY,
    minX,
    minY,
    maxX,
    maxY,
  ) {
    this._maxScaleX = maxScaleX;
    this._maxScaleY = maxScaleY;
    this._maxX = maxX;
    this._maxY = maxY;
    this._minScaleX = minScaleX;
    this._minScaleY = minScaleY;
    this._minX = minX;
    this._minY = minY;
  }

  get maxScaleX() {
    return this._maxScaleX;
  }

  set maxScaleX(value) {
    this._maxScaleX = value;
  }

  get maxScaleY() {
    return this._maxScaleY;
  }

  set maxScaleY(value) {
    this._maxScaleY = value;
  }

  get maxX() {
    return this._maxX;
  }

  set maxX(value) {
    this._maxX = value;
  }

  get maxY() {
    return this._maxY;
  }

  set maxY(value) {
    this._maxY = value;
  }

  get minScaleX() {
    return this._minScaleX;
  }

  set minScaleX(value) {
    this._minScaleX = value;
  }

  get minScaleY() {
    return this._minScaleY;
  }

  set minScaleY(value) {
    this._minScaleY = value;
  }

  get minX() {
    return this._minX;
  }

  set minX(value) {
    this._minX = value;
  }

  get minY() {
    return this._minY;
  }

  set minY(value) {
    this._minY = value;
  }

  equals(inConstraints) {
    if (!Constraints.isConstraints(inConstraints)) {
      throw new Error('Can only compare to a Contraints object.');
    }
    return (
      this._maxScaleX === inConstraints.maxScaleX &&
      this._maxScaleY === inConstraints.maxScaleY &&
      this._maxX === inConstraints.maxX &&
      this._maxY === inConstraints.maxY &&
      this._minScaleX === inConstraints.minScaleX &&
      this._minScaleY === inConstraints.minScaleY &&
      this._minX === inConstraints.minX &&
      this._minY === inConstraints.minY
    );
  }

  static isConstraints(inConstraints) {
    return inConstraints instanceof Constraints;
  }
}
